module.exports = __webpack_public_path__ + "img/checkers.6535ab8d.png";